import { InjectionToken } from '@angular/core';
import { SelectTranslationConfig } from '../interfaces/select-translation-config.interface';

export const SELECT_TRANSLATION_CONFIG = new InjectionToken<SelectTranslationConfig>(
	'SELECT_TRANSLATION_CONFIG'
);
